export const cookiesKeys = {
  REMEMBER_EMAIL: 'app_remember_email',
  USER_EMAIL: 'app_user_email',
};
